

import React from 'react';
import { Modal } from 'antd';

const ShareCampaignModal = (props) => {
  const { 
    isShareModalVisible, 
    setShareModalVisibility, 
    getCampaignDetails, 
    shareCampaign, 
    campaignDetails: detailed 
  } = props;
  const { campaign } = detailed || {};
  const { campaign_info } = campaign || {};
  const { campaignDetails: campaignDetail } = campaign_info || {};
  const { id: campaignId, users_id } = campaignDetail || {};
  return (
    <div>
      <Modal
        title='Share Campaign'
        footer={null}
        maskClosable={false}
        visible={isShareModalVisible}
        onOk={() => setShareModalVisibility(false)}
        onCancel={() => setShareModalVisibility(false)}>
        <div className="modal-body text-center">
          <h5>Do you like this? Share with your friends!</h5>
          <div className="mt-5">
            <div>
              <ul className="share_links">
                <li 
                  onClick={() => {
                    // https://www.facebook.com/sharer/sharer.php?u=https://www.fivevitals.com//events/132/j
                    const pageUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + window.location.href + '/j';
                    window.open(pageUrl, '_blank');
                    shareCampaign(campaignId, users_id || navigator.userAgent, 'facebook').then(() => {
                      getCampaignDetails(campaignId);
                   })}
                  }
                  className="bg_fb">
                  <a href="#!" className="share_icon" rel="tooltip" title="Facebook">
                    <i className="fa fa-facebook"></i>
                  </a>
                </li>

                <li 
                onClick={() => {
                  //http://www.twitter.com/share?url=http://www.google.com/
                  const pageUrl = 'http://www.twitter.com/share?url=' + window.location.href;
                    window.open(pageUrl, '_blank');
                    shareCampaign(campaignId, users_id || navigator.userAgent, 'twitter').then(() => {
                      getCampaignDetails(campaignId);
                    });
                }}
                className="bg_twitter">
                  <a href="#!" className="share_icon" rel="tooltip" title="Twitter">
                    <i className=" fa fa-twitter"></i>
                    </a>
                  </li>

                <li 
                onClick={() => {
                  // https://www.linkedin.com/sharing/share-offsite/?url=https://icause-ff466.web.app/
                  const pageUrl = 'https://www.linkedin.com/sharing/share-offsite/?url=' + window.location.href;
                    window.open(pageUrl, '_blank');
                    shareCampaign(campaignId, users_id || navigator.userAgent, 'twitter').then(() => {
                      getCampaignDetails(campaignId);
                    });
                }}
                className="bg_linkedin">
                  <a href="#!" className="share_icon" rel="tooltip" title="LinkedIn">
                    <i className="fa fa-linkedin"></i>
                    </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ShareCampaignModal;
